var path    = require('./$.path')
  , $export = require('./$.export');

// Placeholder
require('./$.core')._ = path._ = path._ || {};

$export($export.P + $export.F, 'Function', {part: require('./$.partial')});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.function.part.js
// module id = 921
// module chunks = 0